<template>
  <page-outline :title="$t('common.edit_item', {itemname: $t('bank_accounts.bank_account_singular')})">
    <template slot="pageContent">
      <b-row class="m-0 pb-3 no-gutters">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <b-row class="mx-3 form-group">
        <b-col sm="5" class="mb-3">
          <form-write-group-label-input v-model="name" isMandatory
            inputType="text"
            :inputLabel="$t('common.nme')"
            :placeholderValue="$t('bank_accounts.bank_account_name')">
          </form-write-group-label-input>
        </b-col>
        <b-col sm="5" class="mb-3">
          <form-write-group-label-input isMandatory
            inputType="listeSelect"
            :inputLabel="$t('common.account_zone')">
            <select class="form-control" id="sel4" readonly v-model="zone">
              <option v-for="country in countries" :key="country.id"
                :value="country"
                :disabled="country.disabled"
                :selected="country.selected">
                {{ $t('zoneCodes.' + country.label) }}
              </option>
            </select>
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row class="mx-3 form-group" v-for="accountLabel in zone.accountLabel" :key="accountLabel">
        <b-col sm="5" class="mb-3">
          <div class="d-flex align-items-center">
            <label class="mr-5 pr-3">{{ $t('bank_accounts.default_act_label') }}</label>
            <f7-input type="switch" :checked="isDefault" @change="switchDefault"></f7-input>
          </div>
        </b-col>
        <b-col sm="5" class="mb-3">
          <form-write-group-label-input v-model="zone.values[accountLabel]" isMandatory
            inputType="text"
            :inputLabel="$t(accountLabel)"
            :placeholderValue="$i18n.t(accountLabel)">
          </form-write-group-label-input>
        </b-col>
      </b-row>

      <b-row class="accordionForm mx-3 justify-content-end">
        <b-col lg="2" cols="4">
          <b-button variant="primary"
            @click="editAccount">
            <i class="fa-light fa-save"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </b-col>
      </b-row>
        <!-- <div class="showSmallScreenOnly">
          <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="editAccount">
            <f7-icon fa="save" class="fa-2x"></f7-icon>
          </f7-fab>
        </div> -->
    </template>
  </page-outline>
</template>

<script>
import _ from 'lodash'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import backButton from '@/components/common/backButton.vue'

import {extractForeignIban, createForeignIban} from '@/helpers/format'
import {loadPage} from '@/helpers/routing'
import {validateAccountFormat, validateIBAN, validateIBANRIBKey} from '@/helpers/validator'

export default {
  name: 'EditBankAccount',
  props: ['bankAccounts'],
  components: {
    'back-button': backButton,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      iban: '',
      name: '',
      id: 0,
      isDefault: true,
      zone: {},
      zoneCode: '',
      sortCode: '',
      accountNumber: '',
      isSmartphone: false,
      countries: '',
      countryPicker: '',
      returnUrl: '/bankAccounts/'
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.name = this.$settings.modifyAccount.name
    this.zoneCode = this.$settings.modifyAccount.zoneCode
    this.id = this.$settings.modifyAccount.id
    this.isDefault = this.$settings.modifyAccount.isDefault
    this.zone = _.cloneDeep(this.$engine.bankAccounts.getZoneData(this.$settings.modifyAccount.zoneCode))
    if (this.$settings.modifyAccount.isDefault === '0') {
      this.isDefault = false
    } else if (this.$settings.modifyAccount.isDefault === '1') {
      this.isDefault = true
    }

    /** TLV 19/03/2020
    * On extrait les donnees du faux IBAN en base en vraies donnees bancaires,
    * en fonction du pays, dans une variable locale appelee extractedBankData
    */
    let extractedBankData = {}
    if (this.zoneCode !== '' && this.$settings.modifyAccount.iban !== '') {
      extractedBankData = extractForeignIban(this.$settings.modifyAccount.iban, this.zoneCode)
    }
    /** TLV 19/03/2020
    * On cree une variable locale json, qui va etre integree dans this.zone et dans that.countries,
    * qui contient les valeurs actuelles du json pour l'utilisateur selectionne
    */
    let datavalues = {}
    for (var bankData in extractedBankData) {
      datavalues[extractedBankData[bankData].labelId] = extractedBankData[bankData].value
    }
    this.zone.values = datavalues
    let that = this
    let label = []

    that.countries = _.cloneDeep(this.$engine.bankAccounts.getZoneCode())
    for (var country in that.countries) {
      if (that.countries[country].label === this.zoneCode) {
        that.countries[country].values = datavalues
      }
    }
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = this.$i18n.t(p.value[0])
        that.zone = that.countries.filter(function (country) {
          return country.label === p.value[0]
        })[0]
      }
    })
  },
  methods: {
    goBack () {
      loadPage(this, {url: '/bankAccounts/'})
    },
    switchDefault (obj) {
      this.isDefault = obj.target.checked
    },
    editAccount () {
      let defaultValue = ''
      if (this.isDefault === false) {
        defaultValue = '0'
      } else if (this.isDefault === true) {
        defaultValue = '1'
      }
      let that = this

      // Check input formats
      const regexName = /^[\p{L}\p{N}\p{M}][\p{L}\p{N}\p{M}\s'-]*$/u
      if (this.name === '') {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.nme')}))
        return
      }
      if (!regexName.test(this.name)) {
        this.$f7.alert(
            this.$i18n.t('errors.change_to_valid',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.invalid_data_format',
              {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      // Check input formats
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        }
      }

      let ibanValue
      if(this.zone.label === 'EUR') {
        ibanValue = this.zone.values['common.ibn']
      }
      if (validateIBAN(ibanValue) === false || validateIBANRIBKey(ibanValue) === false) {
        this.$f7.alert(
          this.$i18n.t('errors.chng_the_iban_to_vld_frmt'),
          this.$i18n.t('errors.invalid_data_format', {
            invaliddata: this.$i18n.t('contacts.ibn'),
          })
        )
        return
      }
      /* TLV 18/03/2020
      * Cr�ation d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit account
      this.$engine.bankAccounts
        .update({
          id: this.id,
          name: this.name,
          iban: localIban,
          qxban: '',
          isDefault: defaultValue,
          zoneCode: this.zoneCode
        })
        .then(() => {
          this.$f7.modal({
            title: this.$i18n.t('success.updated_success', {data: this.$i18n.t('bank_accounts.bank_account_singular')}),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.name = ''
            that.iban = ''
            that.id = 0
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>
